/**
 * Cache identity for a workspace's execution-image catalog.
 *
 * Mirrors `connectionKeys`'s shape (constitution §2.6) — every key is scoped
 * by workspace: a catalog entry belongs to exactly one.
 */
export const executionImageKeys = {
  all: (workspaceId: string) => ['execution-images', workspaceId] as const,
  list: (workspaceId: string) =>
    ['execution-images', workspaceId, 'list'] as const,
};
